import { render, staticRenderFns } from "./ActivateAccountForm.vue?vue&type=template&id=f12c8420"
import script from "./ActivateAccountForm.vue?vue&type=script&lang=js"
export * from "./ActivateAccountForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports